export const campsiteBookings = (state) => state.campsiteBookings
export const parkingBookings = (state) => state.parkingBookings
export const gatePasses = (state) => state.gatePasses
export const otherCharges = (state) => state.otherCharges
